import React from 'react';

const FundingHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Funding
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          The Funding page helps you track and manage AWS funding programs,
          credits, and promotional benefits available to your organization.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Funding Overview
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          View your funding status at a glance:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>Total Credits:</strong> Available AWS credits</li>
          <li><strong>Used Credits:</strong> Credits already consumed</li>
          <li><strong>Remaining:</strong> Credits still available</li>
          <li><strong>Expiration:</strong> When credits expire</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Funding Programs
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Track different funding sources:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li><strong>AWS Activate:</strong> Startup program credits</li>
          <li><strong>Partner Credits:</strong> Credits from AWS Partner programs</li>
          <li><strong>Promotional Credits:</strong> Special promotions</li>
          <li><strong>Migration Credits:</strong> Credits for migration projects</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Credit Utilization
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
          Monitor how credits are being used:
        </p>
        <ul className="text-sm text-gray-600 dark:text-gray-400 list-disc list-inside space-y-1">
          <li>View usage trends over time</li>
          <li>See which services consume the most credits</li>
          <li>Set alerts for low credit balances</li>
          <li>Plan credit usage before expiration</li>
        </ul>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Requesting Credits
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Work with your partner or AWS account team to request additional
          credits or participate in funding programs. Track pending requests
          and their approval status in this section.
        </p>
      </div>

    </>
  );
};

export default FundingHelp;
